module.exports = __webpack_public_path__ + "static/32-ee3f19df030a9d8ee0103c2025caa8c1.jpg";